import classnames from 'classnames';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const DealsMobileSkeleton = ({ product, card, page, featuredProducts }) => {
	return (
		<li
			data-lazy-sku={product.ColourId}
			className={classnames('p-2 w-full', {
				'md:w-1/2': featuredProducts !== 1,
			})}>
			<div
				ref={card}
				data-page={page}
				className="deals-product bg-white relative rounded-lg border border-solid border-gray-30 p-4 h-full">
				<div className="flex pb-2 justify-between">
					<Skeleton width={90} height={40} />
					<Skeleton width={150} height={40} />
				</div>
				<div className="flex">
					<div className="w-1/2 mr-2">
						<Skeleton height={200} />
						<Skeleton height={20} />
						<Skeleton height={50} />
					</div>
					<div className="flex flex-col w-1/2 justify-between">
						<div>
							<Skeleton />
							<Skeleton width={100} />
							<Skeleton />
							<Skeleton width={100} />
						</div>
						<Skeleton count={3} height={40} />
					</div>
				</div>
			</div>
		</li>
	);
};

export default DealsMobileSkeleton;
